module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1017-b6121d382c32e00157d7bacf45848aee.png";